export const openFileInNewTab = (url) => {
	if (window.location.hostname === "localhost") {
		window.open(`http://bottoli.localhost:8000${url}`, "_blank");
	} else {
		window.open(`${url}`, "_blank");
	}
};
